export default "__VITE_ASSET__7xGtg_Oa__"